import {
  ExtranetCustomerDetailsDto,
  ExtranetCustomerListItemDto,
  ExtranetCustomerUserRoleDto,
  ExtranetCustomerUserRolesDto,
  ExtranetUserDto,
} from '@pharmac-extranet/extranet-api'
import { UseQueryOptions } from '@tanstack/react-query'
import { api } from '../../services/HttpService'

export const customerQueryKeyFactory = {
  getUserCustomers: () => ['__userCustomerships'],
  getCustomerUsers: (id: number) => ['__customershipUsers', { id }],
  getUserCustomer: (customerId: number) => ['__userCustomership', { customerId }],
  getUserCurrentCustomerRoles: (customerId: number) => [
    '__userCurrentCustomerRoles',
    { customerId },
  ],
  getCustomerUserRoles: (id: number, uid: string) => ['__customershipUserRoles', { id, uid }],
  getAllExtranetRoles: (id: number) => ['__allRoles', { id }],
}

export const getUserCustomersQuery = (): UseQueryOptions<Array<ExtranetCustomerListItemDto>> => ({
  queryFn: async () => await api.users.getLoggedInUserCustomers(),
  queryKey: customerQueryKeyFactory.getUserCustomers(),
})

export const getExtranetRolesQuery = (
  id?: number
): UseQueryOptions<Array<ExtranetCustomerUserRoleDto>> => ({
  queryFn: async () => await api.customers.getAvailableRoles(),
  queryKey: customerQueryKeyFactory.getAllExtranetRoles(id as number),
})

export const getCustomerUsersQuery = (id?: number): UseQueryOptions<Array<ExtranetUserDto>> => ({
  queryFn: async () => await api.customers.getCustomerUsers(id as number),
  queryKey: customerQueryKeyFactory.getCustomerUsers(id as number),
  enabled: typeof id === 'number',
})

export const getCustomerUserRolesQuery = (
  id?: number,
  uid?: string
): UseQueryOptions<ExtranetCustomerUserRolesDto> => ({
  queryFn: async () => await api.customers.getCustomerUserRoles(id as number, uid as string),
  queryKey: customerQueryKeyFactory.getCustomerUserRoles(id as number, uid as string),
  enabled: typeof id === 'number' && typeof uid === 'string',
})

export const getUserCustomerQuery = (
  customerId?: number
): UseQueryOptions<ExtranetCustomerDetailsDto> => ({
  queryFn: async () => await api.customers.getCustomerByCustomerId(customerId as number),
  queryKey: customerQueryKeyFactory.getUserCustomer(customerId as number),
  enabled: typeof customerId === 'number',
})

export const getMyCustomerUserRolesQuery = (
  customerId?: number
): UseQueryOptions<ExtranetCustomerUserRolesDto> => ({
  queryFn: async () => await api.customers.getMyCustomerUserRoles(customerId as number),
  queryKey: customerQueryKeyFactory.getUserCurrentCustomerRoles(customerId as number),
  enabled: typeof customerId === 'number',
})
